<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un fournisseur."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- Name Column -->
                    <ng-container matColumnDef="nom">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.nom }}</td>
                    </ng-container>
                    <ng-container matColumnDef="contact">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone</th>
                        <td mat-cell *matCellDef="let element"> {{ element.contact }}</td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email</th>
                        <td mat-cell *matCellDef="let element"> {{ element.email }}</td>
                    </ng-container>
                    <!-- Address Column -->
                    <ng-container matColumnDef="adresse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Adresse</th>
                        <td mat-cell *matCellDef="let element"> {{ element.adresse }}</td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Fournisseur
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="updateForunisseur()">
                <div class="row">
                    <!-- Form fields here -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="nom" placeholder="Ex. Dupont">
                            <mat-error *ngIf="editForm.get('nom')?.hasError('required')">Le nom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse Mail</mat-label>
                            <input type="email" matInput formControlName="email" placeholder="Ex. labo@domain.com">
                            <mat-error *ngIf="editForm.get('email')?.hasError('required')">Email est obligatoire</mat-error>
                            <mat-error *ngIf="editForm.get('email')?.hasError('email')">Le format d'email est invalide</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <textarea matInput formControlName="adresse" placeholder="Ex. 1er étage apt n°2, Résidence BAB ELKHEIR"></textarea>
                            <mat-error *ngIf="editForm.get('adresse')?.hasError('required')">Adresse est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="contact" placeholder="Ex. +123-0123456789">
                            <mat-error *ngIf="editForm.get('contact')?.hasError('required')">Le téléphone est obligatoire</mat-error>
                            <mat-error *ngIf="editForm.get('contact')?.hasError('pattern')">Le format du numéro de téléphone doit être : +123-0123456789</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-primary btn-sm">Sauvegarder</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #viewModal let-modal >
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="row">
                <h5 class="px-3 fw-bold">Détails du fournisseur :</h5>

                <!-- Name and First Name -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom :</div>
                    <p>{{ fourn?.nom }}</p>
                </div>
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Téléphone :</div>
                    <p>{{ fourn?.contact }}</p>
                </div>

                <!-- Email -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Email :</div>
                    <p>{{ fourn?.email }}</p>
                </div>
                <!-- Address, Postal Code, and City -->
                <div class="col-sm-6 col-lg-8 border-top p-3">
                    <div class="fw-bold">Adresse :</div>
                    <p>{{ fourn?.adresse }}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Nouveau Fournisseur
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveFournisseur()">
                <div class="row">
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="nom" placeholder="Ex. Dupont">
                            <mat-error *ngIf="form.get('nom')?.hasError('required')">Le nom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>E-mail</mat-label>
                            <input type="email" matInput formControlName="email" placeholder="Ex. info@mailFournisseur.com">
                            <mat-error *ngIf="form.get('email')?.hasError('required')">L'email est obligatoire</mat-error>
                            <mat-error *ngIf="form.get('email')?.hasError('email')">Le format de l'email est invalide</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="contact" placeholder="Ex. +212 5 23 45 67 89">
                            <mat-error *ngIf="form.get('contact')?.hasError('required')">Le téléphone est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <input matInput formControlName="adresse" placeholder="Ex. 123 Rue des Laboratoires">
                            <mat-error *ngIf="form.get('adresse')?.hasError('required')">L'adresse est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-success btn-sm" [disabled]="form.invalid">Sauvegarder</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>


<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
